module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/san-antonio-27147cd1065d1747732a905716384738.png";